var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;

var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;

function isMobile (opts) {
  if (!opts) opts = {};
  var ua = opts.ua;
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent'];
  }
  if (typeof ua !== 'string') return false

  var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua);

  if (
    !result &&
    opts.tablet &&
    opts.featureDetect &&
    navigator &&
    navigator.maxTouchPoints > 1 &&
    ua.indexOf('Macintosh') !== -1 &&
    ua.indexOf('Safari') !== -1
  ) {
    result = true;
  }

  return result
}

function initDescriptionEvent() {
    const description = isMobile() ? document.querySelector('.for-mobile .mopio-product__description') : document.querySelector('.for-desktop .mopio-product__description');
    const titles = description ? description.querySelectorAll('.mopio-product__description-title') : [];

    titles.forEach(title => {
        title.addEventListener('click', function () {
            const content = this.nextElementSibling;
            this.classList.toggle('active');

            if (content.style.display === "block") {
                content.style.display = "none";
            } else {
                content.style.display = "block";
            }
        });
    });

    const tabs = description ? description.querySelectorAll('.mopio-product__tab-title') : [];

    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            const activeTab = description ? description.querySelector('.mopio-product__tab-title.active') : null;
            if (activeTab) {
                activeTab.classList.remove('active');
            }
            this.classList.add('active');

            const activeContent = description.querySelector('.mopio-product__tab-content:not([style*="display: none"])');
            if (activeContent) {
                activeContent.style.display = 'none';
            }

            const newContentId = this.getAttribute('data-tab');
            const newContent = description.querySelector(`#${newContentId}`);
            if (newContent) {
                newContent.style.display = 'block';
            }    
        });
    });

    const triggers = description ? description.querySelectorAll('.mopio-product__modal-link') : [];
    const modal = document.getElementById('mopio-product__modal-container');
    const modalText = document.getElementById('mopio-product__modal-content-inner');
    const closeModal = document.getElementById('mopio-product__modal-close-icon');

    triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            const dataModal = trigger.getAttribute('data-modal');
            modalText.innerHTML = decodeURIComponent(dataModal);
            modal.style.display = 'flex';
        });
    });


    closeModal.addEventListener('click', () => {
        modal.style.display = 'none';
    });

    window.addEventListener('click', (event) => {
        if (event.target === modal) {
            modal.style.display = 'none';
        }
    });

    const descriptionExpand = description.querySelector('#mopio-product__description-expand');
    const descriptionCollapse = description.querySelector('#mopio-product__description-collapse');

    descriptionExpand.addEventListener('click', () => {
        titles.forEach(title => {
            title.classList.add('active');
            title.nextElementSibling.style.display = 'block';
        })
    });

    descriptionCollapse.addEventListener('click', () => {
        titles.forEach(title => {
            title.classList.remove('active');
            title.nextElementSibling.style.display = 'none';
        })
    });
}

document.addEventListener("DOMContentLoaded", function () { initDescriptionEvent(); });
